import { z } from 'zod';
import { paginationQueryResponse } from './pagination';

export const lessonsSchema = z.object({
  data: z.array(
    z.object({
      courseDocumentId: z.string(), //  masterclass or series or learningPath DOCUMENTID
      courseType: z.string(), // masterclass or series or learningPath
      courseTitle: z.nullable(z.string()), // masterclass or series or learningPath TITLE
      favouriteDocumentId: z.nullable(z.string()),
      lessonDocumentId: z.nullable(z.string()),
      title: z.nullable(z.string()),
      duration: z.nullable(z.number()),
      lessonProgresses: z.nullable(
        z.object({
          progress_status: z.nullable(z.string()),
          current_second: z.nullable(z.number()),
        }),
      ),
      thumbnail: z.nullable(z.object({ url: z.nullable(z.string()) })),
    }),
  ),
  pagination: paginationQueryResponse,
});

export type Lessons = z.infer<typeof lessonsSchema>;
